import * as monaco from "monaco-editor";
import { ref, onMounted } from "vue";
import { createCompletionItemProvider } from "../createCompletionItemProvider";

/**
 * Supsis SDK için otomatik tamamlama sağlar
 * @param {Object} options Konfigürasyon seçenekleri
 * @returns {Object} SDK tamamlama özellikleri
 */
export function useSupsisCompletion(options = {}) {
  const editor = ref(null);
  const modulesLoaded = ref(false);
  
  // Editör bağlandığında çağrılacak fonksiyon
  const registerEditor = (monacoEditor, automationAttributes = []) => {
    editor.value = monacoEditor;
    
    // Global erişim için atama yap (tamamlama için)
    window.editor = monacoEditor;
    
    if (!options.store && window.$store) {
      options.store = window.$store;
    }
    
    // Otomatik tamamlama sağlayıcısını ekle
    const supsisCompletionProvider = createCompletionItemProvider(automationAttributes);
    
    // Tamamlayıcıyı kaydet
    monaco.languages.registerCompletionItemProvider("javascript", supsisCompletionProvider);
    
    // Supsis SDK'yı vurgula
    monaco.languages.typescript.javascriptDefaults.setExtraLibs([
      {
        content: `
          /**
           * Supsis veri erişim SDK'sı
           */
          declare namespace supsis {
            /**
             * Kullanıcı işlemleri
             */
            namespace users {
              function get(id: string): Promise<any>;
              function list(): Promise<any[]>;
            }
            
            /**
             * Bilet işlemleri
             */
            namespace ticket {
              function get(id: string): Promise<any>;
              function create(data: any): Promise<any>;
              function update(id: string, data: any): Promise<any>;
            }
            
            /**
             * Görev işlemleri
             */
            namespace task {
              function get(id: string): Promise<any>;
              function create(data: any): Promise<any>;
              function update(id: string, data: any): Promise<any>;
            }
            
            /**
             * Kişi işlemleri
             */
            namespace contact {
              function get(id: string): Promise<any>;
              function create(data: any): Promise<any>;
              function update(id: string, data: any): Promise<any>;
            }
            
            /**
             * Aktivite işlemleri
             */
            namespace activity {
              function create(options: {
                message: string;
                notification: {
                  users?: Array<{
                    id: string;
                    config: {
                      web?: boolean;
                      email?: boolean;
                      mobile?: boolean;
                    };
                  }>;
                  config: {
                    web?: boolean;
                    email?: boolean;
                    mobile?: boolean;
                  };
                };
                actions?: Array<{
                  action: 'close-supsis-external-widget' | 'open_url_in_new_tab' | 'view_record' | 'start_chat' | 'create_task' | 'show_contact' | 'show_message' | 'make_call' | 'open-widget';
                  payload?: any;
                }>;
              }): Promise<any>;
            }
            
            /**
             * Modül işlemleri
             */
            namespace module {
              function list(): Promise<any[]>;
              
              // Her modül için dinamik olarak eklenir
            }
          }
        `
      }
    ]);
    
    return monacoEditor;
  };
  
  onMounted(() => {
    // Monaco editörü başlatma işlemi
    if (options.initOnMounted && !editor.value) {
      registerEditor(options.editor, options.automationAttributes || []);
    }
  });
  
  return {
    editor,
    registerEditor,
    modulesLoaded
  };
} 